(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tds-colour-options"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tds-colour-options')) {
    customElements.define('tds-colour-options', class extends HTMLElement {
      connectedCallback() {
        this.choices = [...this.querySelectorAll('.tds-colour-choice')];
        this.toggle = this.querySelector('.tds-colour-options__toggle');
        this.limit = Number(this.dataset.limit) || 6;
        if (!this.toggle || this.choices.length <= this.limit) return;
        this.expanded = false;
        this.abortController = new AbortController();
        const options = { signal: this.abortController.signal };
        this.toggle.addEventListener('click', () => {
          this.expanded = !this.expanded;
          this.update();
        }, options);
        this.addEventListener('change', event => {
          if (event.target.matches('[data-st-option-input]')) this.update();
        }, options);
        this.update();
        this.toggle.hidden = false;
        this.setAttribute('data-ready', '');
      }
      disconnectedCallback() {
        this.abortController?.abort();
      }
      update() {
        const selected = this.choices.findIndex(choice => choice.querySelector('input').checked);
        const visible = new Set(this.choices.slice(0, this.limit));
        if (selected >= this.limit) {
          visible.delete(this.choices[this.limit - 1]);
          visible.add(this.choices[selected]);
        }
        this.choices.forEach(choice => {
          choice.toggleAttribute('data-overflow-hidden', !this.expanded && !visible.has(choice));
        });
        this.toggle.textContent = this.expanded ? '−' : '+' + (this.choices.length - this.limit);
        this.toggle.setAttribute('aria-expanded', String(this.expanded));
        this.toggle.setAttribute('aria-label', this.expanded ? this.dataset.lessLabel : this.dataset.moreLabel);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tds-customer-star-style"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tds-customer-star-style')) {
    customElements.define('tds-customer-star-style', class extends HTMLElement {
      connectedCallback() {
        this.observer?.disconnect();
        this.artwork = this.querySelector('template')?.content.firstElementChild;
        if (!this.artwork) return;
        this.starPath = this.artwork.querySelector('path').getAttribute('d');
        const relevant = '.st_reviews_widget, [id^="st_stars_widget_"], .st-review-proof, .quick-buy-modal__reviews, .tds-dual__stars, .tds-community-embedded__stars';
        this.observer = new MutationObserver(records => {
          const changed = records.some(record => {
            if (record.target.nodeType === 1 && record.target.closest(relevant)) return true;
            return [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches(relevant) || node.querySelector(relevant)));
          });
          if (changed) this.scheduleUpdate();
        });
        this.observer.observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['data-signature', 'aria-label'] });
        this.updateStars();
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        cancelAnimationFrame(this.updateFrame);
      }
      scheduleUpdate() {
        if (this.updateFrame) return;
        this.updateFrame = requestAnimationFrame(() => {
          this.updateFrame = null;
          this.updateStars();
        });
      }
      updateStars() {
        document.querySelectorAll('.st-review-proof').forEach(proof => {
          const rating = Number(proof.dataset.signature?.split('|')[0]);
          this.paintStars(proof.querySelector('.st-review-proof__stars'), rating);
        });
        document.querySelectorAll('.st_rvws-summary-stars > svg, .st_rvws-review-stars > svg, .st_rvws-breakdown-label-text > svg').forEach(svg => this.paintNativeStar(svg));
        document.querySelectorAll('.st_rvws-summary-stars, .st_rvws-review-stars').forEach(stars => stars.style.setProperty('gap', '1.6px', 'important'));
        document.querySelectorAll('.st_rvws-breakdown-bar').forEach(bar => bar.style.setProperty('background-color', '#00b67a', 'important'));
        document.querySelectorAll('.tds-dual__stars > svg, .tds-community-embedded__stars > svg').forEach(svg => {
          if (svg.dataset.tdsStarStyle === 'boxed') return;
          const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
          path.setAttribute('d', this.starPath);
          path.setAttribute('fill', '#00b67a');
          svg.setAttribute('viewBox', '0 0 200 200');
          svg.style.background = '#fff';
          svg.replaceChildren(path);
          svg.dataset.tdsStarStyle = 'boxed';
        });
      }
      paintNativeStar(svg) {
        if (svg.dataset.tdsStarStyle === 'boxed') return;
        const gradient = svg.querySelector('linearGradient');
        const state = gradient?.id.match(/_(filled|half|empty)$/)?.[1];
        const path = svg.querySelector('path');
        if (!state || !path) return;
        const stops = [...gradient.querySelectorAll('stop')];
        stops.forEach((stop, index) => {
          const empty = state === 'empty' || state === 'half' && index === 0;
          stop.style.setProperty('stop-color', empty ? '#dbdce4' : '#00b67a', 'important');
          stop.style.setProperty('stop-opacity', '1', 'important');
        });
        svg.setAttribute('viewBox', '0 0 200 200');
        svg.setAttribute('width', '19');
        svg.setAttribute('height', '19');
        svg.style.setProperty('width', '19px', 'important');
        svg.style.setProperty('height', '19px', 'important');
        svg.style.setProperty('background', '#fff', 'important');
        svg.style.setProperty('padding', '0', 'important');
        path.setAttribute('d', this.starPath);
        path.style.setProperty('fill', state === 'half' ? `url(#${gradient.id})` : state === 'empty' ? '#dbdce4' : '#00b67a', 'important');
        path.style.setProperty('stroke', 'none', 'important');
        svg.dataset.tdsStarStyle = 'boxed';
      }
      paintStars(stars, rating) {
        if (!stars || !Number.isFinite(rating) || rating < 0 || rating > 5) return;
        if (stars.dataset.tdsBoxedRating === String(rating) && stars.querySelector('.tds-trust-stars')) return;
        const artwork = this.artwork.cloneNode(true);
        artwork.setAttribute('aria-hidden', 'true');
        artwork.removeAttribute('role');
        artwork.removeAttribute('aria-label');
        const visualRating = Math.round(rating * 2) / 2;
        [...artwork.children].forEach((star, index) => {
          const fill = Math.min(1, Math.max(0, visualRating - index)) * 200;
          const foreground = star.querySelector('svg');
          foreground.setAttribute('width', fill);
          foreground.setAttribute('viewBox', `0 0 ${Math.max(1, fill)} 200`);
        });
        stars.dataset.tdsBoxedRating = String(rating);
        stars.replaceChildren(artwork);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tds-product-recommendations"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('tds-product-recommendations')) {
    customElements.define('tds-product-recommendations', class extends HTMLElement {
      connectedCallback() {
        this.abortController = new AbortController();
        this.track = this.querySelector('.tds-rec__track');
        this.previous = this.querySelector('[data-tds-rec-previous]');
        this.next = this.querySelector('[data-tds-rec-next]');
        this.controls = this.querySelector('.tds-rec__controls');
        const options = { signal: this.abortController.signal };
        this.previous.addEventListener('click', () => this.move(-1), options);
        this.next.addEventListener('click', () => this.move(1), options);
        this.track.addEventListener('scroll', () => this.scheduleUpdate(), { ...options, passive: true });
        this.resizeObserver = new ResizeObserver(() => this.scheduleUpdate());
        this.resizeObserver.observe(this.track);
        if (!this.track.querySelector('.tds-rec__item') && this.dataset.url) {
          this.loadRecommendations();
        } else {
          this.scheduleUpdate();
        }
      }
      disconnectedCallback() {
        this.abortController?.abort();
        this.resizeObserver?.disconnect();
        cancelAnimationFrame(this.updateFrame);
      }
      async loadRecommendations() {
        try {
          const response = await fetch(this.dataset.url, { signal: this.abortController.signal });
          if (!response.ok) return;
          const html = new DOMParser().parseFromString(await response.text(), 'text/html');
          const incoming = html.getElementById(this.id)?.querySelector('.tds-rec__track');
          if (!this.isConnected || !incoming?.querySelector('.tds-rec__item')) return;
          this.track.replaceChildren(...incoming.children);
          this.hidden = false;
          this.scheduleUpdate();
        } catch (error) {
          if (error.name !== 'AbortError') this.hidden = true;
        }
      }
      scheduleUpdate() {
        cancelAnimationFrame(this.updateFrame);
        this.updateFrame = requestAnimationFrame(() => {
          const maxScroll = this.track.scrollWidth - this.track.clientWidth;
          this.controls.hidden = maxScroll <= 2;
          this.previous.disabled = this.track.scrollLeft <= 2;
          this.next.disabled = this.track.scrollLeft >= maxScroll - 2;
        });
      }
      move(direction) {
        const first = this.track.querySelector('.tds-rec__item');
        if (!first) return;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        this.track.scrollBy({
          left: direction * (first.getBoundingClientRect().width + gap),
          behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["tds-shipping-protection"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__tdsShippingProtectionV1) return;
    window.__tdsShippingProtectionV1 = true;

    const configElement = document.getElementById('tds-shipping-protection-config');
    if (!configElement) return;

    const config = JSON.parse(configElement.textContent);
    const variantId = Number(config.variantId);
    const root = window.Shopify?.routes?.root || '/';
    let busy = false;
    let timer;

    const getCart = async () => {
      const response = await fetch(`${root}cart.js`, { credentials: 'same-origin' });
      if (!response.ok) throw new Error('Cart unavailable');
      return response.json();
    };

    const getProtectionItem = (cart) => cart.items.find((item) => Number(item.variant_id) === variantId);
    const getMainItems = (cart) => cart.items.filter((item) => Number(item.variant_id) !== variantId);

    const buildWidget = () => {
      const wrapper = document.createElement('label');
      wrapper.className = 'tds-shipping-protection';
      wrapper.innerHTML = `
        <span class="tds-shipping-protection__shield" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none"><path d="M12 3 19 6v5c0 4.7-2.8 8.4-7 10-4.2-1.6-7-5.3-7-10V6l7-3Z" stroke="currentColor" stroke-width="1.7"/><path d="m8.8 12 2 2 4.5-4.7" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg>
        </span>
        <span class="tds-shipping-protection__copy">
          <strong class="tds-shipping-protection__title"></strong>
          <span class="tds-shipping-protection__description"></span>
        </span>
        <span class="tds-shipping-protection__control">
          <span class="tds-shipping-protection__price"></span>
          <input class="tds-shipping-protection__checkbox" type="checkbox">
        </span>`;
      wrapper.querySelector('.tds-shipping-protection__title').textContent = config.title;
      wrapper.querySelector('.tds-shipping-protection__description').textContent = config.description;
      wrapper.querySelector('.tds-shipping-protection__price').textContent = config.price;
      wrapper.querySelector('input').setAttribute('aria-label', config.ariaLabel);
      return wrapper;
    };

    const showError = (widget) => {
      let error = widget.querySelector('.tds-shipping-protection__error');
      if (!error) {
        error = document.createElement('span');
        error.className = 'tds-shipping-protection__error';
        widget.appendChild(error);
      }
      error.textContent = config.error;
    };

    const hideProtectionLine = () => {
      document.querySelectorAll('.sd-line').forEach((line) => {
        const protectionLink = line.querySelector('a[href*="/products/tds-100-shipping-protection"]');
        line.hidden = Boolean(protectionLink);
      });
    };

    const removeProtection = async (item, cart) => {
      if (!item) return;
      const line = cart.items.findIndex((cartItem) => Number(cartItem.variant_id) === variantId) + 1;
      if (!line) return;
      const response = await fetch(`${root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line, quantity: 0 })
      });
      if (!response.ok) throw new Error('Protection could not be removed');
      if (window.SternifyCart?.cart?.load) {
        await window.SternifyCart.cart.load();
      } else {
        window.location.reload();
      }
    };

    const addProtection = async () => {
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: 1,
            properties: { _is_upsell: 'true', _upsell_type: 'shipping_protection' }
          }]
        })
      });
      if (!response.ok) throw new Error('Protection could not be added');
      if (window.SternifyCart?.cart?.load) {
        await window.SternifyCart.cart.load();
      } else {
        window.location.reload();
      }
    };

    const sync = async () => {
      const footer = document.querySelector('.sd-footer');
      if (!footer) return;

      try {
        const cart = await getCart();
        const protectionItem = getProtectionItem(cart);
        const mainItems = getMainItems(cart);

        // Sternify already excludes the hidden upsell line from its visible product list.

        if (!mainItems.length) {
          document.querySelector('.tds-shipping-protection')?.remove();
          if (protectionItem && !busy) {
            busy = true;
            try {
              await removeProtection(protectionItem, cart);
            } finally {
              busy = false;
            }
          }
          return;
        }

        let widget = footer.querySelector('.tds-shipping-protection');
        if (!widget) {
          widget = buildWidget();
          footer.prepend(widget);
          widget.querySelector('input').addEventListener('change', async (event) => {
            if (busy) return;
            const checkbox = event.currentTarget;
            busy = true;
            widget.setAttribute('aria-busy', 'true');
            checkbox.disabled = true;
            widget.querySelector('.tds-shipping-protection__error')?.remove();
            try {
              const latestCart = await getCart();
              const latestProtection = getProtectionItem(latestCart);
              if (checkbox.checked && !latestProtection) await addProtection();
              if (!checkbox.checked && latestProtection) await removeProtection(latestProtection, latestCart);
            } catch (error) {
              checkbox.checked = !checkbox.checked;
              showError(widget);
            } finally {
              busy = false;
              widget.removeAttribute('aria-busy');
              checkbox.disabled = false;
              window.setTimeout(sync, 80);
            }
          });
        }

        const checkbox = widget.querySelector('input');
        checkbox.checked = Boolean(protectionItem);
      } catch (error) {
        document.querySelector('.tds-shipping-protection')?.remove();
      }
    };

    const scheduleSync = () => {
      window.clearTimeout(timer);
      timer = window.setTimeout(sync, 100);
    };

    new MutationObserver(scheduleSync).observe(document.documentElement, { childList: true, subtree: true });
    document.addEventListener('sternify:cart:updated', scheduleSync);
    document.addEventListener('cart:updated', scheduleSync);
    scheduleSync();
  })();
  } catch(e) { console.error(e); }
})();

})();
